import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { RolesEnum } from "@/lib/types/roles.types";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function getRole(roleNumber: RolesEnum): string {
	switch (roleNumber as RolesEnum) {
		case RolesEnum.OWNER:
		case null: //has no allowed_signups_lab_role since it is the only account without invitation
			return "Besitzer";
		case RolesEnum.ADMIN:
			return "Administrator";
		case RolesEnum.MEMBER:
			return "Mitglied";
		case RolesEnum.COURIER:
			return "Kurier";
		default:
			return "Mitglied";
	}
}
